import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Dimensions from 'react-dimensions';
import bowser from 'bowser';
import { windowResize } from './actions';
import MobileLock from './components/mobile-lock';
import CheckLocalStorage from './containers/check-local-storage';
import SafeLocalStorage from './utils/safe-localstorage';
import OnlineChecker from './containers/online-checker';

class App extends React.Component {
  constructor(props, context) {
    super(props, context);

    const newWindowSizing = {
      windowHeight: props.containerHeight,
      windowWidth: props.containerWidth,
    };

    this.props.onWindowResize(newWindowSizing);
  }

  componentWillReceiveProps(nextProps) {
    const newWindowSizing = {
      windowHeight: nextProps.containerHeight,
      windowWidth: nextProps.containerWidth,
    };

    this.props.onWindowResize(newWindowSizing);
  }

  renderBasedOnBrowser() {
    const isLocalStorageAvailable = SafeLocalStorage.check();
    const isMobileAllowed = _.get(this.props, 'children.props.route.mobileAllowed');
    if (bowser.mobile && !isMobileAllowed) return <MobileLock />;
    if (isLocalStorageAvailable) return <div>{this.props.children}</div>;
    return <CheckLocalStorage />;
  }

  render() {
    return (
      <div>
        <OnlineChecker />
        {this.renderBasedOnBrowser()}
      </div>
    );
  }
}

App.propTypes = {
  onWindowResize: React.PropTypes.func,
};

const mapStateToProps = state => ({
  windowWidth: state.windowSize.get('windowWidth'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onWindowResize: resizeData => dispatch(windowResize(resizeData)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dimensions()(App));



/** WEBPACK FOOTER **
 ** ./src/app.js
 **/